import React from "react";

const th =
  "border px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-gray-300";
const td = "border px-3 py-2 text-xs text-gray-900 dark:text-gray-100";

const toInt = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

const rankLabel = (v) => {
  const n = Number(v);
  if (Number.isFinite(n) && n > 0) return String(n);
  const s = String(v || "").trim().toUpperCase();
  if (s === "NC") return "NC";
  return "—";
};

const PublicResultsTable = ({ rows, onOpenSheet, distById }) => {
  if (!rows || rows.length === 0) {
    return (
      <p className="text-center text-gray-500 dark:text-gray-400">
        Aucun compétiteur trouvé.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto w-full mb-6 bg-white dark:bg-gray-800 rounded-lg shadow-md">
      <p className="mx-auto p-2 text-center text-sm text-gray-200 dark:text-gray-400 bg-gray-900">
        Vous pouvez appuyer sur un compétiteur pour voir le déroulement de ses
        combats.
      </p>

      <table className="table-auto border-collapse min-w-[720px] w-full">
        <thead>
          <tr className="bg-gray-100 dark:bg-slate-700/60">
            <th className={th}>Nom Prénom</th>
            <th className={th}>Club</th>
            <th className={th}>Catégorie</th>
            <th className={th}>Victoires</th>
            <th className={th}>Points</th>
            <th className={th}>Classement</th>
            <th className={th}>Distribution</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((c) => {
            const ageCat = c._age || c.categorie_age || "—";
            const weightCat = c._poids || c.categorie_poids || "—";

            const dist = distById?.get?.(Number(c._distId));
            const genreLabel =
              dist?.genre === "M"
                ? "Masculin"
                : dist?.genre === "F"
                ? "Féminin"
                : "";

            const ageLine = genreLabel ? `${ageCat} • ${genreLabel}` : ageCat;

            const wins = toInt(c.total_victoires, 0);
            const points = toInt(c.total_points, 0);

            const rk = rankLabel(c.classement_position);
            const rkNum = toInt(rk, 0);
            const isMedal = rk === "1" || rk === "2" || rk === "3";

            return (
              <tr
                key={c.id}
                className="text-center odd:bg-white even:bg-gray-50/70 dark:odd:bg-slate-900 dark:even:bg-slate-900/70 hover:bg-blue-50/50 dark:hover:bg-slate-800 transition cursor-pointer"
                onClick={() => onOpenSheet(c)}
                title="Voir la fiche du judoka"
              >
                <td className={`${td} text-left`}>
                  {c.nom_competiteur} {c.prenom_competiteur}
                </td>

                <td className={`${td} text-left`}>{c.club_competiteur}</td>

                <td className={td}>
                  <div className="flex flex-col leading-tight">
                    <span className="font-semibold">{ageLine}</span>
                    <span className="text-[11px] text-gray-500 dark:text-gray-400">
                      {weightCat}
                    </span>
                  </div>
                </td>

                <td className={td}>{wins}</td>
                <td className={td}>{points}</td>

                <td className={`${td} font-bold`}>
                  {rk}
                  {isMedal && rkNum === 1 && " 🥇"}
                  {isMedal && rkNum === 2 && " 🥈"}
                  {isMedal && rkNum === 3 && " 🥉"}
                </td>

                <td className={td}>
                  {c._distId ? (
                    <span className="inline-flex items-center gap-2">
                      <span className="rounded-full bg-slate-100 dark:bg-slate-800 px-2 py-0.5 text-[11px] font-semibold">
                        #{c._distId}
                      </span>
                      {c._tapis != null && (
                        <span className="text-[11px] opacity-75">
                          Tapis {c._tapis}
                        </span>
                      )}
                    </span>
                  ) : (
                    <span className="text-[11px] text-gray-400">—</span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PublicResultsTable;
